"use strict";

angular.module("vendor")
.controller("SectionProductAdd", function(
    $scope, $resource, FlashBag, gettextCatalog, ProductService, ModalService, ProductCategoriesService) {
    $scope.isFetching = false;
    this.service = ProductService;

    $scope.ProductCategories = ProductCategoriesService.query();

    this.importCallBack = function() {
        FlashBag.info(gettextCatalog.getString("The import of your products will begin shortly. You'll receive an email when the process will be done."));
    };

    this.importImages = function(e) {
        e.preventDefault();
        if (!$scope.uploadImagesForm.$valid) {
            return false;
        }
        $scope.isFetching = true;

        var data = new FormData();
        angular.forEach($scope.images, function(value, key) {
            data.append("files", value);
        });

        ProductService.importProductImage(data).then(function onSuccess(response) {
            ModalService.showModal({
                templateUrl: require("vendor/app-core/import-results/product-files-import.modal.html"),
                controller: "ImportResults",
                controllerAs: "uploadProductFilesCtrl",
                inputs: {
                    $attrs: {
                        title: gettextCatalog.getString("Upload result"),
                        data: response.data
                    }
                }
            }).then(function onSuccess(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function() {
                    modal.element.remove();
                });
            });
        }, function onError(response) {
            FlashBag.apiError(response);
        }).finally(function() {
            $scope.isFetching = false;
            angular.element("#images").val(null);
        });
    };

    this.importVariantImages = function(e) {
        e.preventDefault();
        if (!$scope.uploadVariantImagesForm.$valid) {
            return false;
        }
        $scope.isFetching = true;

        var data = new FormData();
        angular.forEach($scope.variantImages, function(value, key) {
            data.append("files", value);
        });

        ProductService.importProductVariantImage(data).then(function onSuccess(response) {
            ModalService.showModal({
                templateUrl: require("vendor/app-core/import-results/product-files-import.modal.html"),
                controller: "ImportResults",
                controllerAs: "uploadProductFilesCtrl",
                inputs: {
                    $attrs: {
                        title: gettextCatalog.getString("Upload result"),
                        data: response.data
                    }
                }
            }).then(function onSuccess(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function() {
                    modal.element.remove();
                });
            });
        }, function onError(response) {
            FlashBag.apiError(response);
        }).finally(function() {
            $scope.isFetching = false;
            angular.element("#variant-images").val(null);
        });
    };

    this.importAttachments = function(e) {
        e.preventDefault();
        if (!$scope.uploadAttachmentsForm.$valid) {
            return false;
        }
        $scope.isFetching = true;

        var data = new FormData();
        angular.forEach($scope.attachments, function(value, key) {
            data.append("files", value);
        });

        ProductService.importProductAttachment(data).then(function onSuccess(response) {
            ModalService.showModal({
                templateUrl: require("vendor/app-core/import-results/product-files-import.modal.html"),
                controller: "ImportResults",
                controllerAs: "uploadProductFilesCtrl",
                inputs: {
                    $attrs: {
                        title: gettextCatalog.getString("Upload result"),
                        data: response.data
                    }
                }
            }).then(function onSuccess(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function() {
                    modal.element.remove();
                });
            });
        }, function onError(response) {
            FlashBag.apiError(response);
        }).finally(function() {
            $scope.isFetching = false;
            angular.element("#attachments").val(null);
        });
    };

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-add.controller.js
// module id = 985
// module chunks = 0